<template>
  <div class="tt__hotspot" @click.stop="hotspotTap" />
  <div v-if="visible" class="tt" @click.stop="resetTimeout">
    <div class="tt__time">{{ formatTime(debugNow) }}</div>
    <input
      class="tt__slider"
      type="range"
      :min="-1440"
      :max="1440"
      step="5"
      v-model.number="offsetMinutes"
      @input="onSlide"
    />
    <div class="tt__btns">
      <button class="tt__btn" @click="setToNow">Now</button>
      <button class="tt__btn tt__btn--close" @click="close">×</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "TimeTravelDebugger",
  data() {
    return {
      visible: false,
      baseMs: null,
      offsetMinutes: 0,
      tapCount: 0,
      tapTimer: null,
      autoCloseTimer: null,
    };
  },
  computed: {
    debugNow() {
      const base = this.baseMs || Date.now();
      return new Date(base + this.offsetMinutes * 60 * 1000);
    },
    isKioskContext() {
      try {
        return this.$store.getters.context === "kiosk";
      } catch {
        return window.location.pathname.includes("/kiosk");
      }
    },
  },
  mounted() {
    window.addEventListener("keydown", this.onKeydown, { passive: false });
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.onKeydown);
    this.clearTimers();
  },
  methods: {
    formatTime(d) {
      if (!(d instanceof Date)) return "";
      // Locale-aware 12-hour time with AM/PM for US
      return d.toLocaleString("en-US", {
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
    },
    onKeydown(e) {
      if (!this.isKioskContext) return;
      // Cmd/Ctrl + T toggle
      if ((e.ctrlKey || e.metaKey) && !e.altKey && !e.shiftKey && (e.key === "t" || e.key === "T")) {
        e.preventDefault();
        this.visible ? this.close() : this.open();
      }
      if (e.key === "Escape" && this.visible) this.close();
    },
    hotspotTap() {
      if (!this.isKioskContext) return;
      this.tapCount += 1;
      if (this.tapTimer) clearTimeout(this.tapTimer);
      this.tapTimer = setTimeout(() => { this.tapCount = 0; this.tapTimer = null; }, 2000);
      if (this.tapCount >= 7) {
        this.tapCount = 0;
        clearTimeout(this.tapTimer);
        this.tapTimer = null;
        this.visible ? this.close() : this.open();
      }
    },
    open() {
      this.visible = true;
      this.baseMs = Date.now();
      this.offsetMinutes = 0;
      this.$store.dispatch("stopTimeUpdates");
      this.applyDebugTime();
      this.startAutoClose();
    },
    close() {
      this.visible = false;
      this.clearTimers();
      this.baseMs = null;
      this.offsetMinutes = 0;
      this.$store.commit("SET_CURRENT_TIME", new Date());
      this.$store.dispatch("startTimeUpdates");
    },
    onSlide() {
      this.applyDebugTime();
      this.resetTimeout();
    },
    setToNow() {
      this.baseMs = Date.now();
      this.offsetMinutes = 0;
      this.applyDebugTime();
      this.resetTimeout();
    },
    applyDebugTime() {
      this.$store.commit("SET_CURRENT_TIME", this.debugNow);
    },
    startAutoClose() {
      this.clearAutoClose();
      this.autoCloseTimer = setTimeout(() => this.close(), 30000);
    },
    resetTimeout() {
      if (this.visible) this.startAutoClose();
    },
    clearAutoClose() {
      if (this.autoCloseTimer) {
        clearTimeout(this.autoCloseTimer);
        this.autoCloseTimer = null;
      }
    },
    clearTimers() {
      this.clearAutoClose();
      if (this.tapTimer) {
        clearTimeout(this.tapTimer);
        this.tapTimer = null;
      }
    },
  },
};
</script>

<style scoped>
.tt {
  position: fixed;
  left: 50%;
  bottom: 20px;
  transform: translateX(-50%);
  z-index: 9999;
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.85);
  padding: 14px 20px;
  border-radius: 999px;
  color: #fff;
  font-size: 15px;
  backdrop-filter: blur(6px);
}
.tt__time {
  min-width: 130px;
  font-weight: 600;
  white-space: nowrap;
  margin-right: 16px;
}
.tt__slider {
  width: 180px;
  height: 28px;
  margin-right: 16px;
  cursor: pointer;
}
.tt__btns {
  display: flex;
}
.tt__btn {
  appearance: none;
  border: none;
  background: rgba(255,255,255,0.15);
  color: #fff;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 14px;
  cursor: pointer;
  margin-left: 8px;
}
.tt__btn:first-child {
  margin-left: 0;
}
.tt__btn--close {
  background: rgba(255,80,80,0.3);
}
.tt__hotspot {
  position: fixed;
  left: 0;
  top: 0;
  width: 50px;
  height: 50px;
  z-index: 9998;
  background: transparent;
}
</style>
